import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowUp, FaWhatsapp, FaInstagram, FaFacebook, FaTwitter, FaCopy } from "react-icons/fa";
import { TbBrandStackshare } from "react-icons/tb";
import { motion } from "framer-motion";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
} from "@chakra-ui/react";
import instance from "../../../axios";

const ReferAndEarn = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [referralCode, setReferralCode] = useState("");
  const [referralStats, setReferralStats] = useState(null);
  const [copied, setCopied] = useState(false);
  const [fetched, setFetched] = useState(false);

  const fetchReferralData = async () => {
    if (fetched) return;
    try {
      const res = await instance.get("/referral/stats");
      if (res.data?.result) {
        setReferralCode(res.data.result.referralCode || "");
        setReferralStats(res.data.result);
      }
      setFetched(true);
    } catch (error) {
      console.error("Referral data error", error);
    }
  };

  const handleOpen = () => {
    fetchReferralData();
    onOpen();
  };

  const shareableLink = referralCode
    ? `https://learn2earn24x7.com/login?ref=${referralCode}`
    : "";

  const handleShare = (platform) => {
    const shareText = `Join Learn2Earn24x7 and start earning while learning! Use my referral code: ${referralCode}\n${shareableLink}`;
    let url;
    switch (platform) {
      case "whatsapp":
        url = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`;
        break;
      case "instagram":
        url = `https://instagram.com/share?url=${encodeURIComponent(shareableLink)}`;
        break;
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareableLink)}`;
        break;
      case "twitter":
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareableLink)}&text=${encodeURIComponent(shareText)}`;
        break;
      default:
        return;
    }
    window.open(url, "_blank");
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralCode || shareableLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <li onClick={handleOpen}>
        <div className="flex">
          <TbBrandStackshare className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
          <span className="ms-3 text-lg font-semibold">Share & Earn</span>
        </div>
      </li>
      <hr />
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={"md"}
        backgroundColor="purple"
        colorScheme="purple"
        className="bg-bgBlue"
      >
        <ModalOverlay />
        <ModalContent
          borderRadius={"20px"}
          backgroundColor={"#4D2C5E"}
          className="bg-bgBlue"
        >
          <ModalHeader
            fontWeight={"700"}
            className="font-bold text-xl text-center text-white underline underline-purple"
          >
            Refer And Earn
          </ModalHeader>
          <ModalCloseButton
            color={"#FF782D"}
            className="text-purple"
            size={20}
          />
          <ModalBody>
            <div className="max-w-md mx-auto bg-bgBlue rounded-xl overflow-hidden md:max-w-2xl">
              <div className="p-4">
                <h2 className="text-2xl font-bold text-white mb-4">
                  Share This Link
                </h2>
                <div className="mb-4">
                  <p className="text-white text-sm mb-1">
                    Your Referral Code:
                  </p>
                  <div className="relative">
                    <input
                      type="text"
                      value={referralCode || "Loading..."}
                      readOnly
                      className="w-full pr-10 py-3 pl-3 border border-purple rounded-md focus:outline-none focus:ring-2 focus:ring-purple text-center font-bold text-lg tracking-widest"
                    />
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      className="absolute inset-y-0 right-0 px-3 flex items-center bg-purple text-white rounded-r-md"
                      onClick={copyToClipboard}
                      aria-label="Copy code"
                    >
                      <FaCopy size={18} />
                    </motion.button>
                  </div>
                </div>
                <div className="flex justify-between items-center mb-4">
                  <motion.button
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    className="bg-green-500 text-white p-3 rounded-full"
                    onClick={() => handleShare("whatsapp")}
                    aria-label="Share on WhatsApp"
                  >
                    <FaWhatsapp size={24} />
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    className="bg-pink-500 text-white p-3 rounded-full"
                    onClick={() => handleShare("instagram")}
                    aria-label="Share on Instagram"
                  >
                    <FaInstagram size={24} />
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    className="bg-blue-600 text-white p-3 rounded-full"
                    onClick={() => handleShare("facebook")}
                    aria-label="Share on Facebook"
                  >
                    <FaFacebook size={24} />
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    className="bg-blue-400 text-white p-3 rounded-full"
                    onClick={() => handleShare("twitter")}
                    aria-label="Share on Twitter"
                  >
                    <FaTwitter size={24} />
                  </motion.button>
                </div>

                <div className="flex flex-col lg:flex-row lg:justify-between justify-center items-center lg:text-start text-center text-md font-bold">
                  <p className="w-44 flex py-2 justify-center items-center gap-1 rounded-full bg-white text-bgBlue transition duration-300 mt-2">
                    Referrals: {referralStats?.totalReferrals || 0}
                  </p>
                  <Link
                    to={"/dash/referral"}
                    className="flex justify-center"
                    onClick={onClose}
                  >
                    <div className="w-44 flex py-2 justify-center items-center gap-1 rounded-full bg-purple text-white transition duration-300 mt-2">
                      <button className="font-bold cursor-pointer text-sm">
                        View Dashboard
                      </button>
                      <FaArrowUp
                        color="white"
                        className="text-white"
                        size={18}
                      />
                    </div>
                  </Link>
                </div>

                {copied && (
                  <motion.p
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    className="text-green-600 text-sm mt-2"
                  >
                    Link copied to clipboard!
                  </motion.p>
                )}
              </div>
              <h1 className="text-white p-2 text-lg font-bold text-center">
                Every Referral You Get 100 Rs
              </h1>
              <p className="text-white p-2 text-sm">
                Earn reward points for each valid referral who signs up using
                your link and get course. Rewards are credited to your account
                and are non-transferable and non-exchangeable.
              </p>
            </div>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="#FF782D"
              className="bg-purple"
              mr={3}
              onClick={onClose}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ReferAndEarn;
